import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, useAttrs, useListeners } from 'vue';
import {
  PaginatedQuery,
  ClientOnboardingReport,
  ClientOnboardingReportFilters,
  ListQuery,
  ExportListType,
  ComplianceStatus,
} from 'ah-api-gateways';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useServices } from 'bd-common/src/services';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { onboardedClientsTableFields } from './inviteClientsListingTableFields';
import ClientStatusPill from './ClientStatusPill.vue';
import OnboardedClientActionsMenu from './OnboardedClientActionsMenu.vue';

interface OnboardedClientsEmit extends UseManagedListingEmits<ClientOnboardingReport> {
  (e: 'view-client', value: ClientOnboardingReport): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardedClientsListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({ tableFields: onboardedClientsTableFields }),
  },
  ...defineUseManagedListingProps<ClientOnboardingReport>(),
},
  emits: ["view-client"],
  setup(__props, { expose, emit }: { emit: ({
  (e: 'view-client', value: ClientOnboardingReport): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;



const services = useServices();
const attrs = useAttrs();
const listeners = useListeners();



const managedListing = useManagedListing<ClientOnboardingReport>({
  loadDataRequest(query: PaginatedQuery<ClientOnboardingReportFilters>) {
    return services.client.listClientOnboardingReport(query);
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
  downloadDataRequest(type, query: ListQuery<ClientOnboardingReportFilters>) {
    return services.client.downloadClientOnboardingReport(query, type as ExportListType);
  },
});

expose({ loadData: managedListing.loadData });

return { __sfc: true,props, services, attrs, listeners, emit, managedListing, ComplianceStatus, formatDate, MaterialIcon, ClientStatusPill, OnboardedClientActionsMenu }
}

})